import React, {Component} from 'react';
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";
import {SaveButton} from "../../business_units/SaveButton";
import {Spinner} from "../../Spinner";
import {Button, Input} from "reactstrap";
import {SpinnerSecondaryButton} from "../../SpinnerSecondaryButton";
import {MultiSelect} from "../../selects/MultiSelect";
import {HELP_WEBHOOK, LinkToArticle} from "../../help_center/LinkToArticle";
import { withTranslation } from 'react-i18next';
import {
    formatPauseDate, pauseOf, resumedBySave, resumedByTest, testErrorReason, testResult, TONE_ERROR, TONE_OK,
} from "./webhookTestResult";

class WebhookComponentClass extends Component {
    constructor(props) {
        super(props);

        this.handleWebhookChange = this.handleWebhookChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTest = this.handleTest.bind(this);
        this.handleEventsChange = this.handleEventsChange.bind(this);

        this.state = {
            testing: false,
            loading: true,
            isSaving: false,
            hasChanges: false,
            hasAccessToModule: null,
            webhookUrl: null,
            // La dirección que el backend tiene guardada: «Probar» con ESA reanuda un webhook pausado.
            savedWebhookUrl: null,
            // `{reasonKey, on}` si la pausa automática lo frenó (`events/webhook_health.py`), o null.
            pause: null,
            // Lo que dijo el último «Probar»: `{tone, key, code, reason, resumed}`, o null.
            testResult: null,
            events: null,
            eventsSelected: null
        };
    }

    getPostData() {
        return {
            "webhook_url": this.state.webhookUrl,
            "events": this.state.eventsSelected
        };
    }

    handleTest() {
        this.setState({testing: true, testResult: null});
        const data = this.getPostData();

        this.testWebhookUrl(data).then((response) => {
            // El backend responde OK aunque el destino conteste 404 o 500: lo que pasó viene en `data`.
            const result = testResult(response);
            const resumed = this.state.pause !== null
                && resumedByTest(result, data.webhook_url, this.state.savedWebhookUrl);
            this.setState({
                testing: false,
                testResult: {...result, reason: testErrorReason(response), resumed},
                pause: resumed ? null : this.state.pause,
            });
        });
    }

    handleSubmit() {

        this.setState({isSaving: true});
        // La dirección que se mandó: si se tipea mientras se guarda, el campo ya dice otra.
        const data = this.getPostData();

        this.postForm(data).then((response) => {
            const { t } = this.props;
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                alert(t('webhook_component.changes_saved_successfully'))
                // Guardar una dirección distinta reanuda el webhook pausado; guardar la misma, no.
                const resumed = resumedBySave(data.webhook_url, this.state.savedWebhookUrl);
                this.setState({
                    hasChanges: false,
                    savedWebhookUrl: data.webhook_url,
                    pause: resumed ? null : this.state.pause,
                });
            } else if (response.status === 'NO_MODULE_ACCESS') {
                alert(response.error_message);
            }
            this.setState({isSaving: false});
        });
    }

    postForm(data) {
        const apiClient = new APIClient(this.getWebhookUrl());
        return apiClient.call('PUT', data);
    }

    testWebhookUrl(data) {
        const apiClient = new APIClient(this.getTestWebhookUrl());
        return apiClient.call('PUT', data);
    }

    componentDidMount() {
        this.getAgencyWebhookConfiguration();
    }

    getEvents() {
        // SI la agencia no tiene acceso al modulo, igual traigo los eventos para que vean cuales hay
        new APIClient(this.getEventsUrl()).call('GET').then((data) => {
            if (data.status === 'ERROR_NO_AGENCY') {
                alert(data['error_message']);
                this.redirectToAgencyRegisterPage()
            } else if (data.status === 'OK') {
                const events = data.data !== undefined ? data.data : [];
                this.setState({
                    events: events,
                    loading: false
                });
            } else {
                alert(data['error_message']);
            }
        })
    }

    getAgencyWebhookConfiguration() {
        new APIClient(this.getWebhookUrl()).call('GET').then((data) => {
            if (data.status === 'ERROR_NO_AGENCY') {
                alert(data['error_message']);
                this.redirectToAgencyRegisterPage()
            } else if (data.status === 'NO_MODULE_ACCESS') {
                this.setState({hasAccessToModule: false});
                this.getEvents();
            } else if (data.status === 'OK') {
                const webhookUrl = data.data !== undefined ? data.data["webhook_url"] : null;
                const events = data.data !== undefined ? data.data["events"] : null;
                const eventsSelected = data.data !== undefined ? data.data["events_selected"] : null

                this.setState({
                    webhookUrl: webhookUrl,
                    savedWebhookUrl: webhookUrl,
                    pause: pauseOf(data.data),
                    events: events,
                    eventsSelected: eventsSelected,
                    hasAccessToModule: true,
                    loading: false
                });
            } else {
                alert(data['error_message']);
            }
        })
    }

    getWebhookUrl() {
        return API_URL + 'webhook-url/';
    }

    getTestWebhookUrl() {
        return API_URL + 'webhook-url/test';
    }

    getEventsUrl() {
        return API_URL + 'events';
    }

    handleWebhookChange(event) {
        const target = event.target;

        this.setState({
            webhookUrl: target.value,
            hasChanges: true,
            testResult: null
        });
    }

    renderSaveButton() {
        const { t } = this.props;
        return <SaveButton text={t('webhook_component.save_button')}
                           isSaving={this.state.isSaving}
                           onClick={this.handleSubmit}
                           hasChanges={this.state.hasChanges}/>
    }

    render() {
        const { t } = this.props;
        return (
            <div className="section-body-item -wider box">
                <header className="box-header">
                    <h2 className="box-title">{t('webhook_component.title')}</h2>
                </header>
                {this.renderInnerComponents()}
            </div>
        )
    }

    renderAccessStatus() {
        const { t } = this.props;
        if (this.state.hasAccessToModule)
            return;

        return <div className="form-row" key="access">
            <div className="alert alert-info">
                {t('webhook_component.agency_plan_required')}
            </div>
        </div>
    }

    renderPauseNotice() {
        const {pause} = this.state;
        if (!pause) return null;

        const { t, i18n } = this.props;
        const date = formatPauseDate(pause.on, i18n && i18n.language);
        const title = date
            ? t('webhook_component.paused_title_on', {date, interpolation: {escapeValue: false}})
            : t('webhook_component.paused_title');
        return <div className="form-row" key="pause">
            <div className="alert alert-warning" data-testid="webhook-paused">
                <strong>{title}</strong> {t(pause.reasonKey)}<br/>
                {t('webhook_component.paused_how')}
            </div>
        </div>
    }

    renderTestResult() {
        const result = this.state.testResult;
        if (!result) return null;

        const { t } = this.props;
        const text = result.reason || t(result.key, {code: result.code});
        const className = result.tone === TONE_OK ? 'text-success'
            : (result.tone === TONE_ERROR ? 'text-danger' : 'text-muted');
        return <p className={`mt-2 mb-0 ${className}`} role="status" data-testid="webhook-test-result">
            {text}{result.resumed ? ` ${t('webhook_component.test_resumed')}` : ''}
        </p>
    }

    renderTestButton() {
        if(this.state.testing === true) {
            return <SpinnerSecondaryButton style={{minWidth:"115px"}} className="btn btn-secondary"/>;
        }

        const { t } = this.props;
        return <Button key="button" className="btn btn-secondary" onClick={this.handleTest}  style={{minWidth:"115px"}}>{t('webhook_component.test_button')}</Button>
    }

    renderInnerComponents() {
        if (this.state.loading === true) {
            return <div className="box-loader">
                <Spinner color="positive"/>
            </div>
        }

        const { t } = this.props;
        return [
            <div className="form-row" key="description">
                <label>{t('webhook_component.description')}<br/>{t('webhook_component.article_link')}&nbsp;&nbsp;➡️<LinkToArticle article={HELP_WEBHOOK}/></label>
            </div>,
            this.renderAccessStatus(),
            this.renderPauseNotice(),
            this.renderWebhookComponents(),
            <React.Fragment key="save">{this.renderSaveButton()}</React.Fragment>
        ];
    }

    renderWebhookComponents() {
        const { t } = this.props;
        return <div className="form-row" key="webhook">
            <div className="form-col col-12 mb-3">
                <label>{t('webhook_component.webhook_url_label')}</label>
                <div className="input-group-append">
                    <Input name="webhookUrl" readOnly={false} type="text" value={this.state.webhookUrl}
                           onChange={this.handleWebhookChange} className="form-control mr-2"/>
                    {this.renderTestButton()}
                </div>
                {this.renderTestResult()}
            </div>
            <div className="form-col col-6">
                <label>{t('webhook_component.events_to_send_label')}</label>
                <MultiSelect
                    items={this.getEventsOptions()}
                    selectedItemIds={this.getSelectedEventsOptions()}
                    onChange={this.handleEventsChange}
                />
            </div>
        </div>
    }

    getEventsOptions() {
        return this.state.events !== null? this.state.events : [];
    }

    getSelectedEventsOptions() {
        return this.state.eventsSelected !== null? this.state.eventsSelected : [];
    }

    handleEventsChange(eventsSelected) {
        this.setState({
            eventsSelected: eventsSelected,
            hasChanges: true
        })
    }
}

export const WebhookComponent = withTranslation()(WebhookComponentClass);
export default WebhookComponent;
